import { useState, useEffect } from 'react';
import { calculateFutureValue } from '../utils/financial-calculations';

const useRetirementCalculator = () => {
  const [initialAmount, setInitialAmount] = useState(50000);
  const [monthlyAmount, setMonthlyAmount] = useState(1200);
  const [expectedReturn, setExpectedReturn] = useState(12,0);
  const [currentAge, setCurrentAge] = useState(45);
  const [retirementAge, setRetirementAge] = useState(65);
  const [inflation, setInflation] = useState(4,4);
  const [showResults, setShowResults] = useState(false);

  const [finalAmount, setFinalAmount] = useState(0);
  const [monthlyIncome, setMonthlyIncome] = useState(0);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const years = retirementAge - currentAge;
    const months = years * 12;

    const monthlyRate = Math.pow(1 + (expectedReturn / 100), 1/12) - 1;
    const inflationImpact = Math.pow(1 + (inflation / 100), years);

    const patrimony = calculateFutureValue(
      monthlyRate,
      months,
      -monthlyAmount,
      -initialAmount,
      0
    );

    const monthlyIncomeValue = (patrimony * monthlyRate) / inflationImpact;

    setFinalAmount(patrimony);
    setMonthlyIncome(monthlyIncomeValue);

    const newChartData = [];

    for (let i = 0; i <= years; i++) {
      const yearPatrimony = calculateFutureValue(
        monthlyRate,
        i * 12,
        -monthlyAmount,
        -initialAmount,
        0
      );

      newChartData.push({
        age: currentAge + i,
        patrimony: yearPatrimony
      });
    }

    setChartData(newChartData);
  }, [initialAmount, monthlyAmount, expectedReturn, currentAge, retirementAge, inflation]);

  const handleCalculate = () => {
    setShowResults(true);
  };

  const closeModal = () => {
    setShowResults(false);
  };

  return {
    initialAmount,
    setInitialAmount,
    monthlyAmount,
    setMonthlyAmount,
    expectedReturn,
    setExpectedReturn,
    currentAge,
    setCurrentAge,
    retirementAge,
    setRetirementAge,
    inflation,
    setInflation,
    finalAmount,
    monthlyIncome,
    chartData,
    showResults,
    handleCalculate,
    closeModal
  };
};

export default useRetirementCalculator;